export enum CardStyleType {
  LARGE_CARD = 'large_card',
  SMALL_CARD = 'small_card'
}
